'use client'

import { FlagProvider } from '@unleash/nextjs'
import { unleashConfig } from '@/services/unleash/config'
import { ReactNode } from 'react'

export function UnleashProvider({ children }: { children: ReactNode }) {
  return <FlagProvider config={unleashConfig}>{children}</FlagProvider>
}
